/**
 * Résultat des edge functions de création de compte (`create-driver-account`,
 * `create-tenant`).
 *
 * Quand l'e-mail avait DÉJÀ un compte confirmé, la fonction ne touche pas à son
 * mot de passe : elle répond `temp_password: null` et `compte_existant: true`.
 * Il ne faut alors jamais afficher « null » : on dit à la personne comment se
 * connecter.
 */
export const MESSAGE_COMPTE_EXISTANT_FONCTION =
  'Ce compte existait déjà : la personne se connecte avec son mot de passe habituel ou « Continuer avec Google ».'

export function aMotDePasseTemporaire(
  r: { temp_password?: string | null | undefined } | null | undefined,
): r is { temp_password: string } {
  return typeof r?.temp_password === 'string' && r.temp_password.length > 0
}
